module.exports = __webpack_public_path__ + "static/media/Title2.a6c107a8.png";